import api from 'core/api';

export const workoutRecordingsModule = 'workoutRecordings';

const loadingStates = {
  start: { loading: true },
  error: { loading: false },
  success: { loading: false },
};

const actions = {
  destroyUserVideo: {
    module: workoutRecordingsModule,
    name: 'destroyUserVideo',
    api: (data) =>
      api.delete(`/workouts/${data?.workoutId}/workout_recordings/${data?.userId}`, data),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingStates,
  },
};

export default {
  actions,
  state: {
    data: [],
    workouts: [],
    membershipBlocks: [],
    error: null,
    loading: false,
  },
};
